<template>
    <div class="dt-lat-long-container">
        <div class="icon-container">
            <fa :icon="['fas', 'search']" class="search-icon" @click="zoomToCoords"/>
        </div>
        <div class="search-container">
            <input type="text" style="display:none" autocomplete="username">
            <b-form-input 
              v-model="latlong" 
              class="input-area" 
              placeholder="Lat, Lon"
              autocomplete="off"
              @keydown.enter="zoomToCoords"
            />
        </div>
    </div>
</template>
<style src="./Data_Tools.css" scoped></style>
  
<style>
.dt-lat-long-container {
    width: 12.5rem;
    height: 2.5rem;
    background-color: #063c6d;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    border-radius: 5px;
    border: 2px #063c6d solid;
    padding-right: 0.625rem;
}
.icon-container {
    height: 100%;
    width: 3.125rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}
.search-container {
    color: white;
    width: 12.5rem;
    height: 75%;
    padding-left: 0.3125rem;
}

.search-container .input-area {
    font-size: 0.7rem !important;
}

.input-area:focus {
    border: none !important;
    border-bottom: 2px white solid !important; 
    border-radius: 0 !important;
    color: white;
    background-color: transparent;
    box-shadow: none !important;
}

.input-area::-webkit-input-placeholder {
  color: white;
  opacity: 0.8;
}
.input-area {
    width: 93%;
    height: 100%;
    border: none !important;
    border-bottom: 2px white solid !important; 
    border-radius: 0 !important;
    color: white;
    background-color: transparent;
    font-weight: 500;
    padding-left: 0.3125rem;
}
.search-icon {
    cursor: pointer;
}
.search-icon:hover {
    opacity: 0.8;
}
.dot {
  height: 4.0625rem;
  width: 4.375rem;
  background-color: #ffffff;
  color: #063c6d;
  border-radius: 50%;
  display: inline-block;
}
</style>

<script>
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style';
import RegularShape from 'ol/style/RegularShape';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import {fromLonLat, transform} from 'ol/proj'

export default {
    name: 'DT_LatLong',
    data() {
        return {
            latlong: null
        }
    },
    props: [
        'map',
        'mapsMode',
        'clickedCoords'
    ],
    methods: {
        async zoomToCoords() {
            if (!this.latlong.includes(',')) {
                this.$bvToast.toast('Invalid Input', {
                    autoHideDelay: 7000,
                    title: 'Error: Invalid Coordinate Input.',
                    toaster: 'b-toaster-bottom-right'
                })
                return;
            }

            // REFACTOR: Refactor the below code to have its own function
            let coords = this.latlong.split(',')
            let x, y, errX, errY, errMsg

            y = parseFloat(coords[0])
            x = parseFloat(coords[1])

            errX = x > 180 || x < -180
            errY = y > 90 || y < -90
            errMsg = 'Please Enter Valid '
            if (errX && errY) {
                errMsg += 'Latitude and Longitude'
            } else if (errX) {
                errMsg += 'Longitude'
            } else if (errY) {
                errMsg += 'Latitude'
            }
            errMsg += '.'
            if (errX || errY) {
                this.$bvToast.toast(errMsg, {
                    autoHideDelay: 7000,
                    title: 'Error: Invalid Coordinates.',
                    toaster: 'b-toaster-bottom-right'
                })
                return
            }
            let newCenter = new transform([x, y], 'EPSG:4326', 'EPSG:3857')
            this.map.getView().animate({zoom: 18}, {center: newCenter})
            
            // Define custom style for the geoMarker
            const hexagonStyle = new Style({
                image: new RegularShape({
                    points: 6, // Number of points for the hexagon
                    radius: 7, // Radius of the hexagon
                    fill: new Fill({ color: 'rgba(6, 60, 109, 0.2)' }), // Fill color
                    stroke: new Stroke({ color: '#00008B', width: 2 }), // Border color and width
                }),
            });
            
            let geoMarker = new Feature({
                type: 'geoMarker',
                geometry: new Point(new fromLonLat([x, y])),
                id: "latLongPointer"
            })

            geoMarker.setStyle(hexagonStyle);

            await this.$emit('addPoint', geoMarker)
        },
        copyCoords(newValue) {
            let lat = newValue[1].toFixed(6)
            let lon = newValue[0].toFixed(6)
            if (!(lat == 0 && lon == 0)) {
                navigator.clipboard.writeText(`${lat}, ${lon}`)
                this.$bvToast.toast('Coordinates copied to clipboard', {
                    autoHideDelay: 2000,
                    title: 'Coordinates Copied',
                    toaster: 'b-toaster-bottom-right'
                })
            }
        }
    },
    watch: {
        clickedCoords: function (newValue) {
            this.copyCoords(newValue)
        }
    }
}
</script>